/**
 *
 */
export function setSourceParams(){
    let parameters = {},
        hash, value, key;
    if (window.location.href.indexOf('?') > -1) {
        let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (let i = 0; i < hashes.length; i++) {
            if (hashes[i].length > 0) {
                hash = hashes[i].split('=');
                key = decodeURI(hash[0]);
                value = hash[1] ? decodeURI(hash[1]) : ``;
                if(value){
                    parameters[key] = value;
                }
            }
        }
    }
    localStorage.removeItem('UTM_source');
    localStorage.removeItem('UTM_medium');
    localStorage.removeItem('UTM_campaign');
    localStorage.removeItem('rcamp');
    localStorage.removeItem('ref');
    localStorage.removeItem('urlreferences');
    localStorage.removeItem('gclid');
    localStorage.removeItem('UTM_content');
    localStorage.removeItem('UTM_term');
    localStorage.removeItem('adid');
    localStorage.removeItem('adsetid');
    localStorage.removeItem('clickid');
    localStorage.removeItem('sitesourcename');
    localStorage.removeItem('placement');
    localStorage.removeItem('refId');
    localStorage.removeItem('ref1Id');

    console.log(parameters);
    if( parameters['utm_source'] || parameters['utm_medium'] || parameters['utm_campaign'] || parameters['rcamp'] || parameters['gclid'] || parameters['utm_content'] || parameters['utm_term'] || parameters['adid'] || parameters['adsetid'] || parameters['clickid'] || parameters['sitesourcename'] || parameters['placement'] || parameters['refId'] || parameters['ref1Id']){
        localStorage.setItem('UTM_source', parameters['utm_source'] ? parameters['utm_source']  : ``);
        localStorage.setItem('UTM_medium', parameters['utm_medium'] ? parameters['utm_medium'] : ``);
        localStorage.setItem('rcamp', parameters['rcamp'] ? parameters['rcamp'] : ``);
        localStorage.setItem('UTM_campaign', parameters['utm_campaign'] ? parameters['utm_campaign'] : ``);
        localStorage.setItem('UTM_content', parameters['utm_content'] ? parameters['utm_content'] : ``);
        localStorage.setItem('UTM_term', parameters['utm_term'] ? parameters['utm_term'] : ``);
        localStorage.setItem('gclid', parameters['gclid'] ? parameters['gclid'] : ``);
        localStorage.setItem('adid', parameters['adid'] ? parameters['adid'] : ``);
        localStorage.setItem('adsetid', parameters['adsetid'] ? parameters['adsetid'] : ``);
        localStorage.setItem('clickid', parameters['clickid'] ? parameters['clickid'] : ``);
        localStorage.setItem('sitesourcename', parameters['sitesourcename'] ? parameters['sitesourcename'] : ``);
        localStorage.setItem('placement', parameters['placement'] ? parameters['placement'] : ``);
        localStorage.setItem('refId', parameters['refId'] ? parameters['refId'] : ``);
        localStorage.setItem('ref1Id', parameters['ref1Id'] ? parameters['ref1Id'] : ``);
    } 
    if(parameters['ref']){
        localStorage.setItem('ref', parameters['ref']);
        localStorage.setItem('urlreferences', parameters['ref']);

    }
}

/**
 *
 * @returns {{source: any | string, medium: any | string, campaign: any | string, ref: any | string}}
 */
export function getSourceParams(){
    return {
        'source' : localStorage.UTM_source || ``,
        'medium' : localStorage.UTM_medium || ``,
        'rcamp' : localStorage.rcamp || ``,
        'campaign' : localStorage.UTM_campaign || ``,
        'ref' : localStorage.urlreferences || ``,
        'gclid' : localStorage.gclid || ``,
        'content' : localStorage.UTM_content || ``,
        'term' : localStorage.UTM_term || ``,
        'adid' : localStorage.adid || ``,
        'adsetid' : localStorage.adsetid || ``,
        'clickid' : localStorage.clickid || ``,
        'sitesourcename' : localStorage.sitesourcename || ``,
        'placement' : localStorage.placement || ``,
        'refId' : localStorage.refId || ``,
        'ref1Id' : localStorage.ref1Id || ``,
    }
}

/**
 *
 */
export function initUtmSource() {
    if (jQuery('.carusel-landing-page #landingmobilepopup').length > 0) {
        jQuery('[name="ref"]').each(function(){
            jQuery(this).val(getSourceParams().ref ? getSourceParams().ref : jQuery(this).val());
        });
        jQuery('[name="utmSource"]').each(function(){
            jQuery(this).val(getSourceParams().source ? getSourceParams().source : jQuery(this).val());
        });
        jQuery('[name="utmMedium"]').each(function(){
            jQuery(this).val(getSourceParams().medium ? getSourceParams().medium : jQuery(this).val());
        });
        jQuery('[name="utmCampaign"]').each(function(){
            jQuery(this).val(getSourceParams().campaign ? getSourceParams().campaign : jQuery(this).val());
        });
        jQuery('[name="rcamp"]').each(function(){
            jQuery(this).val(getSourceParams().rcamp ? getSourceParams().rcamp : jQuery(this).val());
        });
        jQuery('[name="gclid"]').val(getSourceParams().gclid || '');
        jQuery('[name="utmContent"]').val(getSourceParams().content || '');
        jQuery('[name="utmTerm"]').val(getSourceParams().term || '');
        jQuery('[name="adid"]').val(getSourceParams().adid || '');
        jQuery('[name="adsetid"]').val(getSourceParams().adsetid || '');
        jQuery('[name="clickid"]').val(getSourceParams().clickid || '');
        jQuery('[name="sitesourcename"]').val(getSourceParams().sitesourcename || '');
        jQuery('[name="placement"]').val(getSourceParams().placement || '');
        jQuery('[name="refId"]').val(getSourceParams().refId || '');
        jQuery('[name="ref1Id"]').val(getSourceParams().ref1Id || '');
    }
}


/**
 *
 */
// export function setPhoneBySource() {
//     let urlReferences = [];
//     $('.phone-reference dl').each(function(index) {
//         let urlReferencesTitle = $(this).find($('dt')).text();
//         let urlReferencesTel = $(this).find($('dd')).text();
//         urlReferences.push({
//             name:urlReferencesTitle,
//             tel:urlReferencesTel
//         });
//     });
//     jQuery.each(urlReferences, function(name, tel) {
//         let urlReferencesName = urlReferences[name].name;
//         let urlReferencesTel = urlReferences[name].tel;
//         let telNumber = 'tel:'+urlReferencesTel;
//         let telTitle = 'לחץ כדי להתקשר '+urlReferencesTel;
//         if(urlReferencesName === localStorage.urlreferences) {
//             jQuery('header .header-main .call a').attr({
//                 'href': telNumber,
//                 'title': telTitle
//             });
//         }
//     });
// }


// WEBPACK FOOTER //
// assets/scripts/client/source_params.js